module.exports = __webpack_public_path__ + "static/img/a302.59a9ae01.png";